// import axios from 'axios';
// import {refreshToken} from '../redux/auth/authSlice';

// const apiUrl = process.env.REACT_APP_API_URL;
// const apiUrlCompany = process.env.REACT_APP_API_URL_COMPANY;
// const apiUrlCandidate = process.env.REACT_APP_API_URL_CANDIDATE;
// // Create an axios instance for authentication
// const authApi = axios.create ({
//   baseURL: `${apiUrl}`,
//   headers: {
//     'Content-Type': 'application/json',
//   },
//   withCredentials: true,
// });

// // Create an axios instance for other API calls
// const api = axios.create ({
//   baseURL: `${apiUrlCompany}`,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

// // Create an axios instance for other API calls
// const candidateApi = axios.create ({
//   baseURL: `${apiUrlCandidate}`,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

// // Add a request interceptor to the general api instance
// api.interceptors.request.use (
//   config => {
//     const token = localStorage.getItem ('accessToken');
//     if (token) {
//       config.headers['Authorization'] = 'Bearer ' + token;
//     }
//     return config;
//   },
//   error => {
//     return Promise.reject (error);
//   }
// );

// // Add a request interceptor to the candidate api instance
// candidateApi.interceptors.request.use (
//   config => {
//     const token = localStorage.getItem ('accessToken');
//     if (token) {
//       config.headers['Authorization'] = 'Bearer ' + token;
//     }
//     return config;
//   },
//   error => {
//     return Promise.reject (error);
//   }
// );

// // Add a response interceptor to the general api instance
// api.interceptors.response.use (
//   response => {
//     return response;
//   },
//   async error => {
//     const originalRequest = error.config;
//     if (error.response.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;
//       try {
//         const refresToken = localStorage.getItem ('refreshToken');
//         const accessToken = localStorage.getItem ('accessToken');
//         let body = {refresh_token: refresToken, access_token: accessToken};
//         const newToken = await refreshToken (body);
//         // localStorage.setItem ('accessToken', newToken); // Save the new token
//         api.defaults.headers.common['Authorization'] = 'Bearer ' + newToken;
//         originalRequest.headers['Authorization'] = 'Bearer ' + newToken;
//         return api (originalRequest);
//       } catch (tokenRefreshError) {
//         // Handle token refresh error (e.g., redirect to login)
//         console.error ('Token refresh error:', tokenRefreshError);
//         return Promise.reject (tokenRefreshError);
//       }
//     }
//     return Promise.reject (error);
//   }
// );

// // Add a response interceptor to the candidate api instance
// candidateApi.interceptors.response.use (
//   response => {
//     return response;
//   },
//   async error => {
//     const originalRequest = error.config;
//     if (error.response.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;
//       try {
//         const refresToken = localStorage.getItem ('refreshToken');
//         const accessToken = localStorage.getItem ('accessToken');
//         let body = {refresh_token: refresToken, access_token: accessToken};
//         const newToken = await refreshToken (body);
//         // localStorage.setItem ('accessToken', newToken); // Save the new token
//         api.defaults.headers.common['Authorization'] = 'Bearer ' + newToken;
//         originalRequest.headers['Authorization'] = 'Bearer ' + newToken;
//         return api (originalRequest);
//       } catch (tokenRefreshError) {
//         // Handle token refresh error (e.g., redirect to login)
//         console.error ('Token refresh error:', tokenRefreshError);
//         return Promise.reject (tokenRefreshError);
//       }
//     }
//     return Promise.reject (error);
//   }
// );

// export {api, authApi, candidateApi};

import axios from "axios";
import { toast } from "react-toastify";

// Constants
const MAX_RETRY_ATTEMPTS = 3;

// Utility for displaying toast messages
function handleInfoMessage(message) {
  toast.info(message, {
    autoClose: 2000,
    position: "top-center",
  });
}

// Utility for delay
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Base API URLs from environment variables
const apiUrl = process.env.REACT_APP_API_URL;
const apiUrlCompany = process.env.REACT_APP_API_URL_COMPANY;
const apiUrlCandidate = process.env.REACT_APP_API_URL_CANDIDATE;

// Create Axios instances
const authApi = axios.create({
  baseURL: apiUrl,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

const helpAuthApi = axios.create({
  baseURL: apiUrl,
  withCredentials: true, // Keep if your API requires credentials
});

const authApis = axios.create({
  baseURL: apiUrl,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

const api = axios.create({
  baseURL: apiUrlCompany,
  headers: {
    "Content-Type": "application/json",
  },
});

const candidateApi = axios.create({
  baseURL: apiUrlCandidate,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor to handle Authorization headers
const addAuthHeader = (config) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  } else {
    console.warn("[Request] No access token found in localStorage.");
  }
  return config;
};

// Apply the request interceptor to all Axios instances
[authApi, helpAuthApi, authApis, api, candidateApi].forEach((instance) =>
  instance.interceptors.request.use(addAuthHeader, (error) => {
    console.error("[Request Error]", error);
    return Promise.reject(error);
  })
);

// Enhanced response interceptor with retry logic and token refresh
const addResponseInterceptor = (instance) => {
  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      const status = error?.response?.status;

      // Handle 401 Unauthorized errors (token expiration)
      if (status === 401 && !originalRequest._retry) {
        console.warn("[Response] Detected 401 Unauthorized.");
        originalRequest._retry = true;
        let retryAttempts = 0;
        while (retryAttempts < MAX_RETRY_ATTEMPTS) {
          retryAttempts++;
          try {
            // localStorage.clear();
            // sessionStorage.clear();
            // window.location.href = "/login";
            const response = await refreshToken();
            const accessToken = response.access_token;
            if (accessToken) {
              localStorage.setItem("accessToken", accessToken);
              originalRequest.headers[
                "Authorization"
              ] = `Bearer ${accessToken}`;
              return instance(originalRequest); // Retry the original request
            }
          } catch (refreshError) {
            console.error(
              `[Retry Error] Attempt ${retryAttempts} failed.`,
              refreshError
            );
            if (retryAttempts === MAX_RETRY_ATTEMPTS) {
              console.warn("[Retry] Max retry attempts reached. Logging out.");
              localStorage.clear();
              // handleInfoMessage("Session expired. Redirecting to login...");
              // setTimeout(() => {
              //   window.location.href = "/login"; // Redirect to login page
              // }, 2000);
              throw refreshError;
            }
            await delay(1000); // Wait before retrying
          }
        }
      }

      // Log and reject other errors
      console.error("[Response Error]", error);
      return Promise.reject(error);
    }
  );
};

// Apply the response interceptor to all Axios instances
[authApi, authApis, api, candidateApi].forEach((instance) =>
  addResponseInterceptor(instance)
);

// Function to handle token refresh
export const refreshToken = async () => {
  try {
    const refreshToken = localStorage.getItem("refreshToken");

    if (!refreshToken) {
      throw new Error("No refresh token found in localStorage.");
    }

    // Sending the refresh token in the request body
    const response = await authApi.post("/auth/token/refreshtoken", {
      refresh_token: refreshToken,
    });

    const { access_token, refresh_token: newRefreshToken } = response.data;

    if (access_token && newRefreshToken) {
      localStorage.setItem("accessToken", access_token);
      localStorage.setItem("refreshToken", newRefreshToken);
      return { access_token };
    } else {
      throw new Error("Failed to refresh token: Missing tokens in response.");
    }
  } catch (error) {
    console.error(
      "[Refresh Token] Failed to refresh token:",
      error.response?.data || error.message
    );
    throw error;
  }
};

// Export Axios instances
export default api;
export { api, authApi, helpAuthApi, candidateApi, authApis };
